// extracted by mini-css-extract-plugin
export default {"bg_btn":"home-header_bg_btn__lEQSO","bg_login":"home-header_bg_login__lCJLw","bg_register":"home-header_bg_register__-2+oq"};